// Bootstrap
import {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip
} from 'bootstrap';


/**
 * vanilla javascript input mask
 * @doc https://imask.js.org
 */
import IMask from 'imask';

// Aplica mascara de entrada para campos
// do tipo telefone...
// ==============================================
var forms = document.querySelectorAll('form');
forms.forEach((form) => {
    form.querySelectorAll('input[type="tel"]').forEach((input) => {
        input.mask = IMask(input, { mask: [
            { mask:'(00) 0000-0000' },
            { mask:'(00) 00000-0000' }
        ]});
    });
});

// Theme functions

// Event Listener, show new tab
var tabsEl = document.querySelectorAll('button[data-bs-toggle="tab"]');

tabsEl.forEach(function(tabEl) {
    tabEl.addEventListener('shown.bs.tab', function (event) {
        let bsTarget = event.target.dataset.bsTarget;
        document.getElementById(bsTarget.replace('#','')).scrollIntoView();
    });
});

// Event Listener, modal show
document.getElementById('form-modal').addEventListener('show.bs.modal', function (event) {
    let cta = event.relatedTarget.dataset.cta;

    // Atribui o valor do CTA no dataset para o Google Tag Manager.
    this.dataset.cta = cta;

    // Adiciona o valor do CTA no campo hidden.
    this.querySelector('input[name="cta"]').value = cta;

    // Adiciona o valor da URL atual no campo hidden.
    this.querySelector('input[name="url"]').value = window.location.href;
});

// Evento de submit do formulário
document.getElementById('form-modal').querySelector('form').addEventListener('submit', function (event) {
    event.preventDefault();

    // Prepara o cabeçalho da requisição.
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    // Recupera os dados do formulário e transforma em JSON.
    let jsonData = {};
    let formData = new FormData(this);
    formData.forEach((value, key) => { jsonData[key] = value });

    // Coloca o formulário em modo de carregamento e
    // todos os inputs em modo de leitura.
    this.classList.add('loading');
    this.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');
    this.querySelectorAll('input').forEach((input) => {
        input.setAttribute('readonly', 'readonly');
    });

    // Realiza a requisição para a API do Monday.
    fetch("/api/monday/lead", {
        method: "POST",
        headers: headers,
        redirect: "follow",
        body: JSON.stringify(jsonData)
    })
    .then((response) => {
        return response.text(); // Retorna o conteúdo da resposta como texto
    })
    .then((result) => {
        if (result) { // Verifica se há conteúdo na resposta
            const created = JSON.parse(result);

            if (created.data && created.data.create_item && created.data.create_item.id) {
                console.log('sucesso', created.data.create_item.id);

                // Remove o formulário do modo de carregamento e
                // exibe a mensagem de sucesso.
                this.classList.remove('loading');
                this.classList.add('success');
                this.querySelector('button[type="submit"]').removeAttribute('disabled');
                this.querySelectorAll('input').forEach((input) => {
                    input.removeAttribute('readonly');
                });

                // Limpando os campos do formulário
                this.reset();

            } else {
                this.classList.remove('loading');
                this.classList.remove('success');
                this.querySelector('button[type="submit"]').removeAttribute('disabled');
                this.querySelectorAll('input').forEach((input) => {
                    input.removeAttribute('readonly');
                });

                alert('Erro ao processar a resposta:', result);
                console.error('Erro ao processar a resposta:', result);
            }
        } else {
            this.classList.remove('loading');
            this.classList.remove('success');
            this.querySelector('button[type="submit"]').removeAttribute('disabled');
            this.querySelectorAll('input').forEach((input) => {
                input.removeAttribute('readonly');
            });

            alert('Erro na requisição: A resposta da API está vazia.');
            console.error('A resposta está vazia');
        }
    })
    .catch((error) => {
        this.classList.remove('loading');
        this.classList.remove('success');
        this.querySelector('button[type="submit"]').removeAttribute('disabled');
        this.querySelectorAll('input').forEach((input) => {
            input.removeAttribute('readonly');
        });

        alert('Erro na requisição:', error);
        console.error('Erro na requisição:', error);
    });
});
